<template>
  <main :style="'--color1: #2EF7BA; --color2: #0A0F1E;'" v-if="loaded">
    <transition>
      <router-view :site="site" :plans="plans" :cdn_domain="cdn_domain"></router-view>
    </transition>
  </main>
  <footer v-if="loaded && $route.name !== 'docs'">
    <div class="footer-inner centered">
      <div class="footer-brand">
        <div class="logo"></div>
        <p class="footer-tagline">תשתית וידאו מתקדמת לאתר שלך</p>
      </div>
      <div class="footer-links">
        <div class="footer-col">
          <h4>מוצר</h4>
          <ul>
            <li><router-link to="/#features">תכונות</router-link></li>
            <li><router-link to="/#plans">מחירים</router-link></li>
            <li><router-link to="/docs">תיעוד API</router-link></li>
            <li><a href="https://wizzo.market/wizzostream">WizzoStream בקטלוג הכלים של Wizzo</a></li>
          </ul>
        </div>
        <div class="footer-col">
          <h4>חברה</h4>
          <ul>
            <li><router-link to="/terms">תנאי שימוש</router-link></li>
            <li><a href="mailto:support@wizzo.stream">support@wizzo.stream</a></li>
            <li><a href="tel:+972527752229" dir="ltr">052-775-2229</a></li>
          </ul>
        </div>
        <div class="footer-col">
          <h4>התחלה מהירה</h4>
          <ul>
            <li><a :href="'https://dashboard.' + site.domain" target="_blank">התחברות</a></li>
            <li><router-link to="/#plans">הרשמה</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-bottom centered">
      <p>&copy; {{ new Date().getFullYear() }} WizzoStream. כל הזכויות שמורות.</p>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      plans: [],
      cdn_domain: '',
      loaded: false,
    }
  },
  mounted() {
    this.api({ action: 'general'}, (data)=>{
      let words = {}
      if (data.data.wizzo_stream_words) {
        for (let i = 0; i < data.data.wizzo_stream_words.length; i++) {
          const element = data.data.wizzo_stream_words[i];
          words[element.sysName] = element.value
        }
      }
      
      this.$store.words = words;
      this.plans = data.data.plans;
      this.cdn_domain = data.data.cdn_domain || 'cdn.wizzo.stream';
      this.loaded = true
    })
  },
}
</script>

<style lang="scss">
main {
    // logo.png has the white "wizzo"; logo_dark.png (dark letters) is for a light background, which no screen here has
    .logo {  background-image: url(./assets/logo.png); background-position: center center; background-size: contain; background-repeat: no-repeat;
      @media (min-width: 600px) { width: 160px; height: 50px;}
      @media (max-width: 600px) {width: 110px; height: 36px;}
    }
    nav { z-index: 999; position: fixed; top: 0; left: 0; right: 0; padding-block: 12px; background: rgba(10, 15, 30, 0.92); backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px); border-bottom: 1px solid rgba(46, 247, 186, 0.08); display: flex; justify-content: space-between; align-items: center; opacity: 0; transform: translateY(-100%); transition: opacity 0.3s ease, transform 0.3s ease; 
      @media (min-width: 600px) { padding-inline: 60px 30px;}
      @media (max-width: 600px) { padding-inline: var(--gap);}
      &.active {opacity: 1; transform: translateY(0);}
      .btns { display: flex; align-items: center; gap: var(--gap);
        .login { color: var(--text-light); font-weight: 400; font-size: var(--h5); padding: 8px 16px; border: 1px solid rgba(255,255,255,0.2); border-radius: var(--radius_xs); transition: all 0.2s;
          &:hover { border-color: var(--color1); color: var(--color1); }
        }
      }
    }
    .btn { background: var(--color1); text-align: center; color: var(--color2); padding: 12px 28px; font-size: var(--h5); border-radius: var(--radius_xs); font-weight: 700; width: fit-content; transition: all 0.25s ease;
      &:hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(46, 247, 186, 0.3); }
    } 
    .btn-outline { background: transparent; border: 2px solid var(--color1); color: var(--color1); padding: 10px 28px; font-size: var(--h5); border-radius: var(--radius_xs); font-weight: 600; width: fit-content; transition: all 0.25s ease;
      &:hover { background: rgba(46, 247, 186, 0.1); transform: translateY(-2px); }
    }
}

footer { background: var(--color2); border-top: 1px solid rgba(46, 247, 186, 0.08); padding: 60px 24px 0;
  .footer-inner { display: flex; justify-content: space-between; padding-bottom: 40px; border-bottom: 1px solid rgba(255,255,255,0.06);
    @media (max-width: 768px) { flex-direction: column; gap: 40px; }
  }
  .footer-brand { display: flex; flex-direction: column; gap: 12px;
    // the logo rule under main does not reach the footer, so it had no picture
    .logo { width: 140px; height: 45px; background: url(./assets/logo.png) center / contain no-repeat; }
    .footer-tagline { color: var(--text-muted); font-size: var(--h6); }
  }
  .footer-links { display: flex; gap: 60px;
    @media (max-width: 768px) { flex-wrap: wrap; gap: 30px; }
  }
  .footer-col {
    h4 { color: #fff; font-size: var(--h6); font-weight: 700; margin-bottom: 16px; }
    ul { display: flex; flex-direction: column; gap: 10px;
      li { 
        a { color: var(--text-muted); font-size: var(--h6); transition: color 0.2s;
          &:hover { color: var(--color1); }
        }
      }
    }
  }
  .footer-bottom { padding: 24px 0; text-align: center;
    p { color: var(--text-muted); font-size: 13px; opacity: 0.6; }
  }
}
</style>
